import { Fragment } from "react/jsx-runtime";
import Content from "../../../../components/Content/Content";
import ContentHeader from "../../../../components/ContentHeader/ContentHeader";
import ContentWrapper from "../../../../components/ContentWrapper/ContentWrapper";
import ContentFooter from "../../../../components/ContentFooter/ContentFooter";
import { useDispatch, useSelector } from "react-redux";
import { clearSelectedProject, nextStep, prevStep, setProjectSlides } from "../../../../redux/slices/projectDetailsSlice";
import { RootState } from "../../../../redux/store";
import { useEffect } from "react";
import { fetchProjectDetails } from "../../../../apiservice/Chatservice";
import SlideContentHeader from "../SlideContentHeader/SlideContentHeader";
import SlideContentWrapper from "../SlideContentWrapper/SlideContentWrapper";
import './ProjectOverview.scss';
import LoadingSpinner from "../../../../components/LoadingSpinner/LoadingSpinner";

export default function ProjectOverview({ loading }: Readonly<{ loading: boolean }>) {

    const dispatch = useDispatch();
    const { currentStep, selectedProject, projectSlides } = useSelector((state: RootState) => state.projectDetails);
    const handleNextStep = () => {
        dispatch(nextStep())
    }

    const handlePreviousStep = () => {
        currentStep === 1 ? dispatch(clearSelectedProject()) : dispatch(prevStep())
    }

    const slideContents = projectSlides?.map((slide) => slide.contents)?.flat()?.slice(0, 3);

    useEffect(() => {
        (async () => {
            if (selectedProject?.p_id) {
                const response = await fetchProjectDetails(selectedProject.p_id);
                if (response?.slides) {
                    dispatch(setProjectSlides(response.slides));
                }
            }
        })()
    }, [selectedProject, dispatch])

    // Extracted className logic from nested ternary
    let slideContentClass = '';
    if (slideContents.length === 3) {
        slideContentClass = 'three-contents';
    } else if (slideContents.length >= 4) {
        slideContentClass = 'four-contents';
    }

    return (
        <ContentWrapper>
            <Fragment>
                <ContentHeader
                    title={"Project Details"}
                    subTitle={`Projects / ${selectedProject?.p_name}`}
                    handleBack={handlePreviousStep}
                />
                <Content>
                    {
                        loading ? <LoadingSpinner /> : (
                            <div className={`slide-content-wrapper ${slideContentClass}`}>
                                {
                                    slideContents?.map((content) => (
                                        <SlideContentWrapper key={content.title}>
                                            <SlideContentHeader>{content.title}</SlideContentHeader>
                                            <div className="slide-contents" dangerouslySetInnerHTML={{ __html: content.description }}></div>
                                        </SlideContentWrapper>
                                    ))
                                }
                            </div>
                        )
                    }
                </Content>
                <ContentFooter
                    primaryAction={{
                        label: "Next",
                        onClick: handleNextStep
                    }}
                />
            </Fragment>
        </ContentWrapper>
    )
}